import React from 'react';
import './index.less';
import { withRouter } from 'react-router-dom';
import { Tag } from '@beehive/components';
// @ts-ignore
import ArrowSvg from './imgs/arrow.svg?url';
import { useExtra } from '../DetailLayout/context';
import DotDotDot from 'components/DotDotDot';

const ToolBar = (props: any) => {
  const {
    children,
    history,
    location,
    title,
    id,
    productCode,
    stateName,
  } = props;

  const prefixClx = 'bidding-detail-tool-bar';
  const extraValue = useExtra();

  const handleBackList = () => {
    history.push({
      ...location,
      search: '',
    });
  };

  return (
    <div className={`${prefixClx}`}>
      <div className={`${prefixClx}-left`}>
        {extraValue.showBack ? (
          <div
            className={`${prefixClx}-left-back-btn`}
            onClick={handleBackList}
          >
            <img src={ArrowSvg} alt="" />
          </div>
        ) : null}
        <div className={`${prefixClx}-left-text`}>
          <span className={`${prefixClx}-left-text-id`}>{`#${id}`}</span>
          <DotDotDot height={1} className={`${prefixClx}-left-text-title`}>
            {title}
          </DotDotDot>
        </div>
        <Tag
          text={<DotDotDot height={1}>{stateName}</DotDotDot>}
          isElliptical
          size="small"
          className={`${prefixClx}-left-tag`}
        />
        <Tag
          text={<DotDotDot height={1}>{productCode}</DotDotDot>}
          isElliptical
          className={`${prefixClx}-left-tag`}
          colorOpposite
          size="small"
          style={{
            backgroundColor: 'white',
            display: 'none', // 隐藏 所属产品
          }}
        />
      </div>
      <div className={`${prefixClx}-right`}>{children}</div>
    </div>
  );
};

export default withRouter(ToolBar);
